import styled from "styled-components";
import dropDownArrowIcon from "assets/icons/dropDownArrowIcon.svg";
import { pxToRem } from "styles/utils";
import {
  DropdownControl,
  DropdownMenu,
  DropdownOptionItem,
} from "../DropdownPrimitives.styles";

export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DropdownInput = styled(DropdownControl)``;

export const DropdownIcon = styled.span<{ $isOpen: boolean }>`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  height: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  background: url(${dropDownArrowIcon}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
  transform: translateY(-50%) rotate(${({ $isOpen }) => ($isOpen ? "0deg" : "180deg")});
  transition: transform 0.2s ease-in-out;
`;

export const DropdownList = styled(DropdownMenu)``;

export const DropdownItem = styled(DropdownOptionItem)<{ isSelected?: boolean }>`
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.inkSoftDark : theme.colors.inkSoft};
`;
